module.exports = __webpack_public_path__ + "img/政策法规.91c89120.jpg";